import React from 'react'
import { observer } from 'mobx-react'
import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import DateInput from '../input/date'
import EditView from 'bstrap-react-mobx-admin/view/edit'
import PropTypes from 'prop-types'
import SelectInput from '../input/select'
import SelectWithSuggestions from '../input/select_suggested'
import TextInput from 'bstrap-react-mobx-admin/input/text'
import { Helmet } from 'react-helmet'
import { Button } from 'react-bootstrap'

const YTAssetsForm = observer(({ state }) => {
  const record = state.cv.record
  const errors = state.cv.errors
  const updateField = state.cv.updateData.bind(state.cv)
  const disabled = !state.hasRight(linkConst.LINK_YOUTUBE_ASSETS, 'w')
  const thisID = record.has('id') && record.get('id')
  const thisVideoID = (record.has('video_id') && record.get('video_id')) || ''

  return (
    <div className='row'>
      <Helmet title={state.__(linkConst.LINK_YOUTUBE_ASSETS_TITLE).concat(defaultConst.HTML_DIVIDER) + (record.has('id')
        ? (record.get('id') ? 'ID ' + record.get('id') : state.__(defaultConst.TITLE_EDIT))
        : state.__(defaultConst.TITLE_CREATE))} />

      <div className='col-xs-12'>
        <SelectWithSuggestions label={state.__('film')} attr={'video_id'} record={record}
          onChange={updateField} labelattr='title' valueattr='id'
          optionsrecord={state.options} optionsattr={'films'} errors={errors} />
        <TextInput label={state.__('asset ID')} attr={'asset_id'} record={record}
          onChange={updateField} errors={errors} />
        <TextInput label={state.__('name')} attr={'asset_name'} record={record}
          onChange={updateField} errors={errors} />
        <SelectInput label={state.__('asset type')} attr='asset_type' record={record}
          onChange={updateField} labelattr='text' valueattr='value'
          valueFilterFc={i => !i.text.includes('video')} disabled={disabled}
          optionsrecord={state.options} optionsattr='UploadTypes' errors={errors} />
        <DateInput label={state.__('created at')} attr={'asset_created_dt'} record={record}
          onChange={updateField} errors={errors}
          disabled={disabled} />
        <TextInput label={state.__('note')} attr={'note'} record={record}
          onChange={updateField} errors={errors} />
      </div>
      {thisID && <div className='col-xs-12'><br />
        {thisVideoID > 0 &&
        <Button bsStyle='info' style={{ marginRight: '0.5em' }}
          onClick={() => state.solvedAsset(thisID, JSON.parse(JSON.stringify(record)), thisVideoID)}>
          <i className='glyphicon glyphicon-ok' />&nbsp; {state.__(defaultConst.TITLE_SOLVED)}
        </Button>}
        <Button bsStyle='danger' onClick={() => {
          if (confirm('Are you sure you want to remove item #' + thisID + '?')) { state.removedAsset(thisID, true) }
        }}>
          <i className='glyphicon glyphicon-remove' />&nbsp; {state.__(defaultConst.TITLE_REMOVE)}
        </Button>
      </div>}
    </div>
  )
})

YTAssetsForm.propTypes = {
  state: PropTypes.object.isRequired
}

const YTAssetsView = ({ store }) => {
  if (!store.hasRight(linkConst.LINK_YOUTUBE_ASSETS)) {
    return <h1>{store.__('insufficient rights')}</h1>
  }

  return (
    <EditView store={store.cv} onReturn2list={store.onReturn2list.bind(store)}
      enabled={store.hasRight(linkConst.LINK_YOUTUBE_ASSETS, 'w')} >
      <YTAssetsForm state={store} />
    </EditView>
  )
}

export default YTAssetsView
